// eslint-disable-next-line no-shadow
export enum CITIES {
  MOSCOW = 'MOSCOW',
  NOVOSIBIRSK = 'NOVOSIBIRSK',
}
